/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ListSkillTagsResult = {
  /**
   * Distinct tags used by active skills in the project, sorted lexicographically.
   */
  tags: Array<string>;
};

/** @internal */
export const ListSkillTagsResult$inboundSchema: z.ZodMiniType<
  ListSkillTagsResult,
  unknown
> = z.object({
  tags: z.array(z.string()),
});

export function listSkillTagsResultFromJSON(
  jsonString: string,
): SafeParseResult<ListSkillTagsResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ListSkillTagsResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ListSkillTagsResult' from JSON`,
  );
}
